import React from "react";

export default function Terms() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-white md:mt-14">
      <h1 className="text-3xl md:text-4xl font-bold mb-6 text-lime-400">
        Terms & Conditions – iqcage.com
      </h1>

      <p className="mb-4">
        Welcome to <strong>iqcage.com</strong>. By accessing or using our
        platform, you agree to be bound by the following terms and conditions.
        If you do not agree with any part of these terms, please do not use our
        services.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        1. Eligibility
      </h2>
      <p className="mb-4">
        You must be at least 18 years old or the legal age in your jurisdiction
        to use our services. By using iqcage.com, you confirm that you meet this
        requirement.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        2. User Account
      </h2>
      <p className="mb-4">
        You are responsible for maintaining the confidentiality of your account
        login information. You agree to notify us immediately of any
        unauthorized access or use of your account.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        3. Virtual Currency & Games
      </h2>
      <p className="mb-4">
        All games on iqcage.com are played using virtual currency. Real money is
        used only for deposits and withdrawals. Winning depends on skill and
        chance based on game mechanics. iqcage.com is not a gambling site.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        4. Prohibited Conduct
      </h2>
      <ul className="list-disc list-inside mb-4 space-y-1">
        <li>No cheating, hacking, or exploiting game bugs.</li>
        <li>
          Do not impersonate other users or use bots to manipulate gameplay.
        </li>
        <li>
          Do not post offensive, threatening, or unlawful content on our
          platform.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        5. Intellectual Property
      </h2>
      <p className="mb-4">
        All content, logos, and software on iqcage.com are the property of
        iqcage and protected by copyright laws. Unauthorized use is strictly
        prohibited.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        6. Termination
      </h2>
      <p className="mb-4">
        We reserve the right to suspend or terminate your account if you violate
        these terms. In serious cases, legal action may be pursued.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        7. Limitation of Liability
      </h2>
      <p className="mb-4">
        iqcage.com is not liable for any losses or damages resulting from use of
        the platform, including loss of virtual currency or interrupted service.
      </p>

      <h2 className="text-2xl font-semibold text-lime-300 mt-6 mb-2">
        8. Modifications
      </h2>
      <p className="mb-4">
        We may update these Terms at any time. Continued use of iqcage.com after
        changes means you accept the updated terms.
      </p>

      <p className="mt-8 italic text-sm text-slate-400">
        Last updated:{" "}
        {new Date().toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>
    </div>
  );
}
